export default "__VITE_ASSET__DuCbXAWF__"